import { showToastSuccess } from '@core/components/toastify/ToastTypes';
import { Modal } from 'antd';
import learningPathApi from 'api/learningPathApi';
import ThemeButton from 'components/AntdFormInputs/theme-button';
import { handleToastError } from 'helpers';
import { useUser } from 'hooks';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Spinner } from 'reactstrap';
import { checkUserAsync } from 'store/auth';

const LearningPathModal = () => {
  const user = useUser();
  const dispatch = useDispatch();
  const router = useRouter();
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pathData, setPathData] = useState([]);

  useEffect(() => {
    if (user && user.isOnboarded && user.isStaffRequest) {
      setModal(true);
      fetchLearningPath();
    }
  }, [user, router.pathname]);

  const fetchLearningPath = async () => {
    try {
      const params = {
        page: 1,
        isDownload: true,
        staffType: user?.staffType?._id ?? user?.staffType,
        courseCentre: user?.courseCentre[0]._id
      };
      const response = await learningPathApi.get(params);
      const learningPaths = response?.data?.map((dt) => ({
        user: user._id,
        learningPath: dt?._id,
        courseCentre: user?.courseCentre?.[0]?._id,
        staffType: dt?.staffType?._id,
        isOnboarding: true,
      }));
      setPathData(learningPaths);
    } catch (error) {
      handleToastError(error);
    }
  };

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const payload = {
        user: user._id,
        learningPaths: pathData,
        proceed: true,
      };
      await learningPathApi.userEnroll(payload);
      showToastSuccess('Process completed successfully');
      dispatch(checkUserAsync());
      setModal(false);
    } catch (e) {
      handleToastError(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      centered
      visible={modal}
      onCancel={() => setModal(false)}
      width={400}
      className="notice-custom-modal"
      footer={[
        <div className="text-center my-50">
          <ThemeButton
            key="assign"
            padding="8px 10px"
            onClick={onSubmit}
            disabled={isLoading}
          >
            {isLoading && (
              <Spinner
                animation="$border"
                role="status"
                style={{
                  width: 17,
                  height: 17,
                }}
                className="mr-05"
              />
            )}
            Proceed
          </ThemeButton>
        </div>,
      ]}
      title={
        <p className="welcom-notices-title-label mb-0 text-center">
          Important Notice
        </p>
      }
      destroyOnClose
    >
      {/* {options.map((item) => (
          <Col key={item.id} className="d-flex mb-1 align-items-center">
            {completedIds.includes(item.id) ? (
              <IoCheckmarkDoneCircle size={20} color="green" />
            ) : errorIds.includes(item.id) ? (
              <BsXCircleFill size={20} color="red" />
            ) : loadingId === item.id ? (
              <Puff
                visible
                height="20"
                width="20"
                color="gray"
                ariaLabel="puff-loading"
              />
            ) : (
              <MdOutlineRadioButtonUnchecked size={20} color="gray" />
            )}
            <h6 className="mb-0 ml-1">{item.title}</h6>
          </Col>
        ))} */}
      <div className="text-center">
        <h6 className="important-notice-tittle mb-0 my-50">
          Welcome to MindChamps
        </h6>
        <h6 className="important-notice-tittle">Learning Management System!</h6>
        {/* <img
          src="/images/learningpath.png"
          alt="learningpath"
          width={'100%'}
          style={{ aspectRatio: '16/9' }}
          height={'auto'}
        /> */}
      </div>
      <div className="text-center">
        <p className="sub-heading_text_title mb-50">
          We have yet to assign a learning path for you,
        </p>
        <p className="sub-heading_text_title mb-0 my-50">
          please click the <span style={{ color: '#c4161c' }}>'Proceed'</span>{' '}
          button.
        </p>
      </div>
    </Modal>
  );
};

export default LearningPathModal;
